import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { authenticatedApi } from "api";

export function useRestore(queryParams) {
    const queryClient = useQueryClient();
    const { queryKey } = queryParams;

    return useMutation({
        mutationFn: async () => {
            const { data: response } = await authenticatedApi.put(`/${queryKey[0]}/${queryKey[1]}`, {restore: true});
            return response;//data.hasOwnProperty('data') ? data.data : data;
        },
        onSuccess: () => {
            console.log(queryKey);
            queryClient.invalidateQueries({ queryKey: [queryKey[0]] });
            // queryClient.invalidateQueries({ queryKey });
        },
    });
}
